import { io } from 'socket.io-client'

// Always use VITE_API_URL if provided, fallback to localhost for local dev
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000'

// Extract base URL and path for Socket.IO
// If API_URL is 'https://domain.com/api', we need domain as URL and '/api/socket.io' as path
const url = new URL(API_URL)
const baseURL = `${url.protocol}//${url.host}` // e.g., 'https://domain.com'
const socketPath = url.pathname === '/' ? '/socket.io' : `${url.pathname}/socket.io` // e.g., '/api/socket.io'

if (import.meta.env.DEV) {
  console.log('Socket.IO connecting to:', baseURL, 'with path:', socketPath)
}

export const socket = io(baseURL, {
  path: socketPath, // Explicitly set the Socket.IO path
  transports: ['websocket', 'polling'], // Try websocket first, fallback to polling
  autoConnect: true,
  withCredentials: true,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionAttempts: 5,
})

socket.on('connect', () => {
  if (import.meta.env.DEV) {
    console.log('Socket connected to:', baseURL, socketPath)
  }
})

socket.on('connect_error', (error) => {
  if (import.meta.env.DEV) {
    console.error('Socket connection error:', error.message)
    console.error('Attempted to connect to:', baseURL, socketPath)
  }
})

socket.on('disconnect', (reason) => {
  if (import.meta.env.DEV) {
    console.warn('Socket disconnected:', reason)
  }
})
